import { render, staticRenderFns } from "./PanelPromoteCompetition.vue?vue&type=template&id=849a75aa&scoped=true&"
import script from "./PanelPromoteCompetition.vue?vue&type=script&lang=js&"
export * from "./PanelPromoteCompetition.vue?vue&type=script&lang=js&"
import style0 from "./PanelPromoteCompetition.vue?vue&type=style&index=0&id=849a75aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849a75aa",
  null
  
)

export default component.exports